'use client';

import { useContext } from 'react';
import { PopupConfirmContext } from './Context';

export const usePopupConfirmContext = () => {
	const context = useContext(PopupConfirmContext);
	if (context === undefined) {
		throw new Error(
			'usePopupConfirmContext must be used within a PopupConfirmProvider',
		);
	}
	return context;
};
